module.exports = __webpack_public_path__ + "img/button diameter.50700102.png";